import React, { useContext } from 'react';
import { Box, Divider } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { Version } from 'config/config';
import clsx from 'clsx';
import CompanyFooter from 'routes/Pages/Certification/CompanyFooter';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  btnRoot: {
    [theme.breakpoints.down('sm')]: {
      padding: '6px 12px',
      fontSize: 11,
    },
  },
  darkAppFooter: {
    backgroundColor: '#000',
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  lightAppFooter: {
    backgroundColor: theme.palette.background.paper,
  },
}));

const Footer = props => {
  const classes = useStyles();
  const date = new Date();

  const rootColor = 'rgba(255,255,255,1)';
  const textColor = 'rgba(255,255,255,1)';

  return (
    <>
      <CompanyFooter />
      <Divider sx={{ height: '1px', bgcolor: '#fff' }} />
      <Box
        className={clsx(classes.root, classes.darkAppFooter)}
        data-footer="app-footer"
        sx={theme => ({
          py: 2,
        })}
        {...props}>
        <Box display="flex" alignItems="center" sx={theme => ({ color: rootColor })} className={classes.darkAppFooter}>
          <Box fontSize={{ xs: 12, sm: 14 }} component="p" color={textColor} ml={5}>
            {`Copyright © ${date.getFullYear()} BRP Inc. All Rights Reserved.`}
          </Box>
        </Box>
        <Box display="flex" alignItems="center" sx={theme => ({ color: rootColor })} className={classes.darkAppFooter}>
          <Box fontSize={{ xs: 12, sm: 14 }} component="p" color={textColor}>
            {Version}
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default Footer;
